<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <h5>{{Core.Definition.getDefinition('Calendrier des événements')}}</h5>
            </b-col>
            <b-col>
                <b-button-group class="pull-right">
                    <b-button @click="switchView('list')" :class="{ 'btn-info': dataView === 'list', 'btn-light': dataView !== 'list' }" class="btn"><i class="fa fa-list mr-1"></i>{{Core.Definition.getDefinition('Liste')}}</b-button>
                    <b-button @click="switchView('week')" class="btn" :class="{ 'btn-info': dataView === 'week', 'btn-light': dataView !== 'week' }" ><i class="fa fa-calendar mr-2"></i>{{Core.Definition.getDefinition('Semaine')}}</b-button>
                    <b-button @click="switchView('month')" class="btn" :class="{ 'btn-info': dataView === 'month', 'btn-light': dataView !== 'month' }"><i class="fa fa-calendar-o mr-2"></i>{{Core.Definition.getDefinition('Mois')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <EventCalendarList v-if="dataView==='list'"></EventCalendarList>
                <EventCalendarWeek v-if="dataView==='week'"></EventCalendarWeek>
                <EventCalendarMonth v-if="dataView==='month'"></EventCalendarMonth>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import EventCalendarList from './EventCalendarList'
    import EventCalendarWeek from './EventCalendarWeek'
    import EventCalendarMonth from './EventCalendarMonth'
    export default {
        name: 'EventCalendarPanel',
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        date: {
                            firstDayOfWeek: 'monday',
                        }
                    }
                }
            }
        },
        components: {
            EventCalendarWeek,
            EventCalendarMonth,
            EventCalendarList
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataView: 'week'
            }
        },
        methods: {
            switchView(view) {
                this.dataView = view
            }
        }
    }
</script>
